export default "__VITE_ASSET__BjcSSsaC__"